import { render, staticRenderFns } from "./RequestDocumentsList.vue?vue&type=template&id=1368544e&"
import script from "./RequestDocumentsList.vue?vue&type=script&lang=js&"
export * from "./RequestDocumentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports